module.exports = __webpack_public_path__ + "static/img/grac-oidd-competition-proposal.68fcd03.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/grac-oidd-competition-proposal.jpg
// module id = HGHd
// module chunks = 0